export default "__VITE_ASSET__BO_Jip$H__"